import { legacy_createStore as createStore } from "redux";

import { appReducer } from "../ducks";

const global = globalThis as any;

const extension =
  process.env.NODE_ENV !== "production" && global.__REDUX_DEVTOOLS_EXTENSION__ && global.__REDUX_DEVTOOLS_EXTENSION__();

export function store() {
  return createStore(appReducer, extension);
}

export function getSingletonStore(): ReturnType<typeof store> {
  if (!(getSingletonStore as any).instance) {
    (getSingletonStore as any).instance = store();
  }
  return (getSingletonStore as any).instance;
}
